export default __webpack_public_path__ + "static/media/projectBg.9e8a9c0a.png";